var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"matching-card",class:{
    'matching-card--selected': _vm.isSelected,
    'matching-card--faded': _vm.isFaded && !_vm.isDisabled,
    'matching-card--disabled': _vm.isDisabled,
  }},[_vm._t("action"),_c('div',{staticClass:"matching-card__header"},[_vm._t("header")],2),_c('div',{staticClass:"matching-card__body"},[_vm._t("body"),_c('div',{staticClass:"matching-card__footer"},[_vm._t("footer")],2)],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }